/*AppProvider.tsx*/
import React, { createContext, useContext, useState,useEffect } from "react";

// Context


const SessionContext = createContext({});

// Custom Hook lo llamas de cualquier lado con
// import { useAppProvider } from '../contexts/AppProvider';
export function useSessionProvider() {
  return useContext(SessionContext);
}

// Functional Component 

export const SessionProvider = ({setTimer,children}) => {  
  return (
    <SessionContext.Provider
      value={{ setTimer }}
    >
      {children}
    </SessionContext.Provider>
  );
};
